import styled from '@happymoneyinc/styled-components';
import PropTypes from 'prop-types';
import { jsxs, jsx } from 'react/jsx-runtime';

const DotButtons = _ref => {
  let {
    selectedIndex,
    onScrollTo,
    scrollSnaps,
    disabled,
    className,
    id,
    testID,
    children,
    css
  } = _ref;
  if (!Array.isArray(scrollSnaps) || scrollSnaps.length <= 1) return null;
  return /*#__PURE__*/jsxs(_StyledCarouselDotsButtonContainer, {
    it: id,
    "data-testid": testID,
    $_css: css,
    children: [scrollSnaps === null || scrollSnaps === void 0 ? void 0 : scrollSnaps.map((_, index) => {
      return /*#__PURE__*/jsx(CarouselDotsButton, {
        className: `embla__dot ${className}`,
        type: "button",
        onClick: () => onScrollTo(index),
        disabled: disabled,
        selected: selectedIndex === index,
        "data-testid": `${testID}-${index}-button`
      }, index.toString());
    }), children]
  });
};
const CarouselDotsButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
var _StyledCarouselDotsButtonContainer = styled(CarouselDotsButtonContainer)`${p => p.$_css}`;
const CarouselDotsButton = styled.button`
  appearance: none;
  background: unset;
  border: none;
  height: 11px;
  outline: 0;
  position: relative;
  touch-action: manipulation;
  width: 11px;
  &:after {
    background-color: ${props => {
  var _props$theme, _props$theme$colors;
  return props !== null && props !== void 0 && props.selected ? props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$colors = _props$theme.colors) === null || _props$theme$colors === void 0 ? void 0 : _props$theme$colors.gray['2'] : 'transparent';
}};
    border-radius: 50%;
    border: 1px solid ${props => {
  var _props$theme2, _props$theme2$colors;
  return props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$colors = _props$theme2.colors) === null || _props$theme2$colors === void 0 ? void 0 : _props$theme2$colors.gray[!(props !== null && props !== void 0 && props.selected) ? '3' : '2'];
}};
    content: '';
    height: 5px;
    left: 50%;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 5px;
  }
  &:hover {
    cursor: pointer;
  }
  &:disabled {
    opacity: 0.3;
    &:hover {
      cursor: not-allowed;
    }
  }
`;
DotButtons.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  css: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  scrollSnaps: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  onScrollTo: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  /** data-test-id's to handle elements inside the DotsButtons component */
  testID: PropTypes.string
};
DotButtons.defaultProps = {
  children: null,
  className: '',
  css: undefined,
  disabled: false,
  id: '',
  testID: 'dot'
};
var DotButtons$1 = DotButtons;

export { DotButtons$1 as default };
//# sourceMappingURL=DotButtons.js.map
